<script>
  import { _ } from '../services/i18n'

  export let mobile = false

  $: suffix = mobile ? '-mobile' : ''

  $: fields = [
    {
      name: 'FNAME',
      id: 'name-register',
      label: $_('login_register_name'),
      type: 'text'
    },
    {
      name: 'EMAIL',
      id: 'email-register',
      label: $_('login_register_email'),
      type: 'email'
    },
    {
      name: 'MMERGE5',
      id: 'company-register',
      label: 'Empresa',
      type: 'text'
    },
    {
      name: 'MMERGE10',
      id: 'country-register',
      label: 'País',
      type: 'text'
    }
  ]
  const clearAfterSubmit = event => {
  const form = event.currentTarget

  // Esperamos a que el navegador recoja los datos para enviarlos.
  setTimeout(() => {
    form.reset()
  }, 0)
}
</script>

<h1>{$_('login_register_title')}</h1>
<h2>{$_('login_register_subtitle')}</h2>

<form
  id="register-form"
  action="https://fenabel.us11.list-manage.com/subscribe/post"
  method="post"
  target="_blank"
  rel="noopener noreferrer"
  on:submit={clearAfterSubmit}
>
  <input
    type="hidden"
    name="u"
    value="145cadb5f91bcec7cccf66522"
  >
  <input type="hidden" name="id" value="b3923b239f">
  <input type="hidden" name="f_id" value="00e615e1f0">

  {#each fields as field}
    <div class="form-group-ph">
      <input
        type={field.type}
        name={field.name}
        id={field.id + suffix}
        placeholder={mobile ? field.label : ''}
        aria-label={field.label}
        required
      >
      {#if !mobile}
        <label for={field.id + suffix}>
          {field.label}<span>*</span>
        </label>
      {/if}
    </div>
  {/each}

  <!-- Campo antispam de Mailchimp: debe permanecer vacío. -->
  <div
    aria-hidden="true"
    style="position: absolute; left: -5000px;"
  >
    <input
      type="text"
      name="b_145cadb5f91bcec7cccf66522_b3923b239f"
      tabindex="-1"
      value=""
      autocomplete="off"
    >
  </div>

  <button
    type="submit"
    class="btn-3d third"
    id="mc-embedded-subscribe"
  >
    {$_('login_register_send')}
  </button>
</form>